import * as Actions from '../../../../Modules/CmsActions'

const initialState = {
  loading: false,
  openCreateModal: false,
  site_list: [],
  pagination: {
    current_page: 1,
    first_page_url: null,
    from: 1,
    last_page: 1,
    last_page_url: null,
    next_page_url: null,
    path: null,
    per_page: 1,
    prev_page_url: null,
    to: 1,
    total: 1,
  },
}

const UIServiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case Actions.SUCCESS_FETCH_SERVICES:
      return updateServiceList(state, action.payload.services)

    default:
      return state
  }
}

function loaded(state) {
  return { ...state, loading: false }
}

function updateServiceList(state, services) {
  return loaded({
    ...state,
    site_list: services.data.map(
      ({
        id,
        name,
        display_name,
        domain,
        domain_type: domainType,
        public: isPublic,
        site_monitoring,
        is_used_seo_tag,
        is_used_seo_tag_v2,
        is_used_embed_script_tag,
        is_used_favicon_tag,
        is_create_post_type,
        has_top_page,
      }) => ({
        id,
        name: name,
        domain: domain,
        domainType,
        display_name,
        isPublic,
        site_monitoring,
        is_used_seo_tag,
        is_used_seo_tag_v2,
        is_used_embed_script_tag,
        is_used_favicon_tag,
        is_create_post_type,
        has_top_page,
      }),
    ),
    pagination: services,
  })
}

export default UIServiceReducer
